import { render, staticRenderFns } from "./deposits.vue?vue&type=template&id=e8f12232&scoped=true&"
import script from "./deposits.vue?vue&type=script&lang=js&"
export * from "./deposits.vue?vue&type=script&lang=js&"
import style0 from "./deposits.vue?vue&type=style&index=0&id=e8f12232&scoped=true&lang=css&"
import style1 from "./deposits.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f12232",
  null
  
)

export default component.exports